import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
} from "reactstrap";
import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LOGO_WHITE from "Assets/Images/LOGO_WHITE.png";
import Screen1 from "Assets/Images/SCREEN1.png";
import Screen2 from "Assets/Images/Scrren2.png";
import Screen3 from "Assets/Images/Screen3.png";
import Screen4 from "Assets/Images/Screen4.png";
import PropTypes from "prop-types";
import ClosedIcon from "Assets/Icons/ClosedIcon";
import ArrowRightActiveIcon from "Assets/Icons/ArrowRightActiveIcon";
import Typography from "Components/CommonComponents/Typography";
import "./index.css";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const items = [
  {
    src: Screen2,
    altText: "Slide 1",
    caption: "Slide 1",
    key: 1,
  },
  {
    src: Screen3,
    altText: "Slide 2",
    caption: "Slide 2",
    key: 2,
  },
  {
    src: Screen4,
    altText: "Slide 3",
    caption: "Slide 3",
    key: 3,
  },
];
const StyledImg = styled<any>("img")`
  height: ${({ height }) =>
    height < 520 ? "22vh !important" : "42vh !important"};
`;
function IOSWalkthroughPWA(props: any) {
  const { windowSize }: any = useWindowSize();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [isShowFlow, setIsShowFlow] = useState(false);
  const { modalOpen, setModalOpen, installApp, installLater } = props;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: any) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img
          className={[1, 2, 3].includes(item.key) ? "slidesImagecarousel" : ""}
          src={item.src}
          alt={item.altText}
        />
        <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        />
      </CarouselItem>
    );
  });
  const returnCarouselMessage = (index: any) => {
    let returnComp;
    if (index == 0) {
      returnComp = (
        <>
          <div className="iOSfirstpopupSecondary">
            Tap on the share icon on the bottom nav bar
          </div>
        </>
      );
    } else if (index == 1) {
      returnComp = (
        <>
          <div className="iOSfirstpopupSecondary">
            Tap on “Add to Home Screen”
          </div>
        </>
      );
    } else if (index == 2) {
      returnComp = (
        <>
          <div className="iOSfirstpopupSecondary">
            Tap on add on the top nav bar
          </div>
        </>
      );
    }
    return returnComp;
  };
  return (
    <>
      {isShowFlow ? null : (
        <ModalHeader>
          <div className="closedIcon">
            <ClosedIcon onClick={() => setModalOpen(!modalOpen)} />
          </div>
          <div className="installiOSModalHeader">
            <img src={LOGO_WHITE} />
          </div>
        </ModalHeader>
      )}
      {!isShowFlow ? (
        <ModalBody className="installModalBody">
          <div className="d-flex justify-content-center">
            <StyledImg src={Screen1} height={windowSize.height} />
          </div>
          <div className="iOSfirstpopupMain">
            {isSafari
              ? "Install Aakash Guru"
              : "Install app from Safari browser"}
          </div>

          <Typography variant="label" color="white">
            {isSafari
              ? "Follow the instructions to install the app for easy access"
              : "Open the link in Safari browser and follow the instructions to install the app for easy access."}
          </Typography>
        </ModalBody>
      ) : (
        <ModalBody className="installModalBody">
          <Carousel
            className="carouselMainContainer"
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            slides={true}
          >
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
            />
            {slides}
            <CarouselControl
              direction="prev"
              directionText="Previous"
              onClickHandler={previous}
            />
            <CarouselControl
              direction="next"
              directionText="Next"
              onClickHandler={next}
            />
          </Carousel>
          <div>{returnCarouselMessage(activeIndex)}</div>
        </ModalBody>
      )}
      <ModalFooter
        className={`d-flex ${
          isShowFlow
            ? "justify-content-center mt-n2"
            : "justify-content-between mt-n2"
        }`}
      >
        <div onClick={installLater} className="stayDiv">
          Stay on web
        </div>
        {!isShowFlow && (
          <Button
            size="sm"
            className="installAppBtn"
            onClick={() => {
              installApp();
              setIsShowFlow(!isShowFlow);
            }}
          >
            How to install&nbsp;
            <ArrowRightActiveIcon className="mt-1 ml-1" />
          </Button>
        )}
      </ModalFooter>
    </>
  );
}

IOSWalkthroughPWA.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  installApp: PropTypes.func,
  installLater: PropTypes.func,
};
export default IOSWalkthroughPWA;
